import { specGet } from "./util";
import axios from "axios";
// import { keycloak } from "../keycloak"

const baseURL =
  (process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_BASE_API_URL
    : "") + "/api/webapp/v1/"; // "/api/app/v1";

const request = axios.create({
  baseURL,
});

// API names used for identifying api spec
// Always use this for API names instead of direct string literals
export const ApiNames = {
  FEATURED_OFFER: "FEATURED_OFFER",
  SUB_MERCHANT_CATEGORY_SEARCH: "SUB_MERCHANT_CATEGORY_SEARCH",
  COLLECTION_LIST: "COLLECTION_LIST",
  BANNER_BY_ID: "BANNER_BY_ID",
  BANNER_LIST: "BANNER_LIST",
  OFFER_SEARCH: "OFFER_SEARCH",
  OFFER_BY_ID: "OFFER_BY_ID",
  OFFER_BY_CODE: "OFFER_BY_CODE",
  SUB_MERCHANT_BY_ID: "SUB_MERCHANT_BY_ID",
  SUB_MERCHANT_BY_CODE: "SUB_MERCHANT_BY_CODE",
  COLLECTION_OFFER_SEARCH: "COLLECTION_OFFER_SEARCH",
  SUBMERCHANT_LIST: "SUBMERCHANT_LIST",
};

// API specs map API names to their respective specs
const apiSpecs = {
  [ApiNames.COLLECTION_OFFER_SEARCH]: specGet("/collection/search"),
  [ApiNames.SUB_MERCHANT_BY_ID]: (id) => specGet(`/submerchant/${id}`),
  [ApiNames.SUB_MERCHANT_BY_CODE]: (code) =>
    specGet(`/submerchant/${code}/detail`),
  [ApiNames.OFFER_BY_ID]: (id) => specGet(`/offer/${id}`),
  [ApiNames.OFFER_BY_CODE]: (code) => specGet(`/offer/${code}/detail`),
  [ApiNames.OFFER_SEARCH]: specGet("/offer/search"),
  [ApiNames.COLLECTION_LIST]: specGet("/collection/list"),
  [ApiNames.BANNER_BY_ID]: (id) => specGet(`/banner/${id}`),
  [ApiNames.BANNER_LIST]: specGet("/banner/list"), // /banner/list
  [ApiNames.SUB_MERCHANT_CATEGORY_SEARCH]: specGet(
    "/submerchant/category/search"
  ),
  [ApiNames.FEATURED_OFFER]: specGet("/collection/featured"),
  [ApiNames.SUBMERCHANT_LIST]: specGet("/submerchant/list"),

  // [ApiNames.SPACES_ADD]: specPost("/spaces"),
  // [ApiNames.SPACES_VIEW]: spaceId => specGet(`/spaces/${spaceId}`),
  // [ApiNames.SPACES_UPDATE]: spaceId => specPut(`/spaces/${spaceId}`)
};

export function fetchData(
  apiName,
  { pathValues, body, params, multipart = false } = {}
) {
  let formData;
  if (multipart) {
    formData = new FormData();
    Object.entries(body).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((v) => {
          formData.append(key, v);
        });
      } else {
        formData.append(key, value);
      }
    });
  }

  let apiSpec = apiSpecs[apiName];
  if (!apiSpec) {
    const msg = "You might have forgotten to add API spec.";
    console.error(msg);
    throw new Error(msg);
  }

  if (typeof apiSpec === "function") {
    apiSpec = apiSpec(...pathValues);
  }

  // console.log(keycloak.token)
  // const keycloak = { token: process.env.NODE_ENV === "production" ? process.env.REACT_APP_API_ACCESS_TOKEN_PROD : ""}; //token
  return request({
    method: apiSpec.method,
    url: apiSpec.url,
    data: multipart ? formData : body && transformRequest(body),
    params,
    // headers: { Authorization: `Bearer ${keycloak.token}`, ...(multipart && { "content-type": "multipart/form-data" }) }
  }).then((res) => res.data);
}

export function transformRequest(obj) {
  // console.log(obj)
  // return obj //added because of issue schedule and other page where speakers: {} being sent rather than speakers: []
  // also issue in speakers - Need to modify or remove transformRequest from pages having mutipart: true

  return Object.entries(obj).reduce((acc, [key, value]) => {
    // console.log("v", value, typeof value)
    if (value === "") {
      acc[key] = null;
    } else if (!Array.isArray(value) && value && typeof value === "object") {
      acc[key] = transformRequest(value);
    } else {
      acc[key] = value;
    }
    return acc;
  }, {});
}
